import eprGuidesReducer from "./eprGuidesSlice";

export default eprGuidesReducer;
